<app-table [data]="reasons"
           [config]="tableConfig"
           title="{{'admin.reasons.table.title' | translate}}"
           [rowExpand]="false"
           [isLoading]="isLoading"
           [isMaterial]="false"
           [hasTitle]="hasTitle"
           [headerBackgroundColor]="headerBackgroundColor"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)"
           (rowClick)="onRowClick($event)">
    <app-table-column header="{{'admin.reasons.table.columns.name' | translate}}"
                      filter="true"
                      filterPlaceholder="{{'admin.reasons.table.filter.placeholder.name' | translate}}"
                      sortable="true"
                      field="name">
    </app-table-column>
    <app-table-column header="{{'admin.reasons.table.columns.scope' | translate}}"
                      field="scope">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="scopeFilters"
                          valueField="value"
                          displayField="name"
                          emptyText="{{'admin.reasons.table.filter.placeholder.scope' | translate}}"
                          (selectItem)="table.onFilterChange(column)">
            </app-dropdown>
        </ng-template>
        <ng-template #body
                     let-record="rowData">
            {{ getScopeTranslationKey(record.scope) | translate }}
        </ng-template>
    </app-table-column>
</app-table>
